import { useOktaAuth } from "@okta/okta-react";
import { Image, SSOLoginForm } from "best-common-react";
import React, { useEffect } from "react";
import navLogo from "../assets/requesttix-logo.png";

const Login: React.FC = () => {
  const { oktaAuth } = useOktaAuth();

  const loginFunc = (): void => {
    oktaAuth.signInWithRedirect();
  };

  useEffect(() => {
    const path = window.location.pathname + window.location.search;
    oktaAuth.setOriginalUri(path);
  }, []);

  return (
    <SSOLoginForm
      title={<Image src={navLogo} height="40px" alt="Requestix Logo" />}
      signInText="Sign In With MLB SSO"
      signIn={loginFunc}
      teamBackDrop
    />
  );
};

export default Login;
